export default "__VITE_ASSET__DPIUElWG__"